module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/04e28ba12fe914cf4f131dcb85ae82d6.svg";